import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Status from 'src/Components/Status'
import Text from 'src/Components/Text'

import styles from './CreateHomeLoading.module.scss'

const propTypes = {
  className: PropTypes.string,
  verified: PropTypes.bool,
  searched: PropTypes.bool,
  gathered: PropTypes.bool,
  crunched: PropTypes.bool
}

const Item = ({ complete, children }) => (
  <li className={styles.item}>
    <Status
      className={classnames(styles.status, complete && styles.completeStatus)}
      complete={complete}
    />
    <Text
      className={classnames(styles.explain, complete && styles.completeExplain)}
      element='span'
      size='l'
    >
      {children}
    </Text>
  </li>
)

const CreateHomeLoading = ({
  className,
  verified,
  searched,
  gathered,
  crunched
}) => (
  <div className={classnames(styles.root, className)}>
    <ul className={styles.list}>
      <Item complete={verified}>
        <FormattedMessage
          id='NewHome.CreateHome.verifying'
          defaultMessage='Verifying street address'
        />
      </Item>
      <Item complete={searched}>
        <FormattedMessage
          id='NewHome.CreateHome.searching'
          defaultMessage='Searching public records'
        />
      </Item>
      <Item complete={gathered}>
        <FormattedMessage
          id='NewHome.CreateHome.gathering'
          defaultMessage='Gathering home facts'
        />
      </Item>
      <Item complete={crunched}>
        <FormattedMessage
          id='NewHome.CreateHome.crunching'
          defaultMessage='Crunching loan data'
        />
      </Item>
    </ul>
  </div>
)

CreateHomeLoading.propTypes = propTypes

export default CreateHomeLoading
